export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-die-two-35f33f8d83ff6d42ee17427227220fb0.svg";